import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";
import ModuleQuestion from "../../components/ModuleQuestion";

const Module_1_0 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}

      <main className="col-sm-8 module-content">
        <section>
          <h1 className="blue text-uppercase b mt-5 mb-4">3.0.15 Case 15</h1>
          <p className="me-4">Estimated time to complete: 3-5 minutes</p>
        </section>
        <ModuleQuestion
          correctAnswer="B"
          assessmentName="self_assessment_115"
          videoTranscript={
            <>
              <p>
                <strong>AUDIO</strong>
                <br />
                VO: (FEMALE)
                <br />
                This is self-assessment case number one, one, five, or 115. This
                is a negative case. Beginning at the level of the cerebellum and
                moving superiorly, we enter into the temporal and occipital
                lobes, seen here. Distinct white matter tracts are identifiable
                on the left as well as on the right. This pattern continues
                throughout the temporal and occipital lobes. Less intense
                activity is seen in the gray matter surrounding the white matter
                tracts on both sides. At this level, there may be some concern
                that there is mildly increased activity in the gray matter
                surrounding the white matter tract. It is important to review
                the slices immediately above and below this to ensure that the
                white matter tract is well delineated. Continuing upwards, we
                enter into the frontal lobes, over here. As you can see, this
                patient is tilted backwards, thus delaying entrance into the
                frontal lobes. Once in the frontal lobes, however, it is clear
                that distinct white matter tracts can be seen on the right as
                well as on the left. Less intense uptake is seen surrounding the
                white matter, finger-like projections. The white matter within
                the frontal cortices makes the pronounced concave structures,
                previously seen. Also seen are distinct white matter tracts
                extending from the front of the brain to the back, on the left
                as well as on the right. There is no loss of gray-white contrast
                in these regions. Towards the top of the brain, once again white
                matter tracts are easily discriminated on the left and on the
                right. Furthermore, in the medial parietal region, there is
                preserved gray-white contrast. There is no increased activity
                within the medial parietal gray matter. Therefore, as there is
                no loss of gray-white contrast, this case is negative. If you
                called this case positive, please review this scan once again in
                the MIM Viewer, concentrating on the regions described.
              </p>
            </>
          }
          previousLesson="/module-3/module-3-0-14"
          nextLesson="/module-3/module-3-0-16"
          iframeURL="https://cdnapisec.kaltura.com/p/1759891/sp/175989100/embedIframeJs/uiconf_id/24639831/partner_id/1759891?iframeembed=true&playerId=kaltura_player_1055034940&entry_id=1_cid3e90o&wid=_1759891&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true"
          questionType="assessment"
          videoId="1_cid3e90o"
        />
      </main>
    </div>
  );
};

export default Module_1_0;
